import { ModeType } from '@eastcoal/common/types/build'

/**
 * 构建模式
 */
export const BUILD_MODE = import.meta.env.MODE as ModeType

/**
 * API 服务地址
 */
export const API_SERVER_URL = import.meta.env.VITE_API_SERVER_URL

/**
 * mall 服务地址
 */
export const MALL_BASE_URL = import.meta.env.VITE_MALL_BASE_URL

/**
 * member 服务地址
 */
export const MEMBER_BASE_URL = import.meta.env.VITE_MEMBER_BASE_URL

/**
 * operation 服务地址
 */
export const OPERATION_BASE_URL = import.meta.env.VITE_OPERATION_BASE_URL

/**
 * support 服务地址
 */
export const SUPPORT_BASE_URL = import.meta.env.VITE_SUPPORT_BASE_URL

/**
 * weboffice 服务地址
 */
export const WEB_OFFICE_SERVER_URL = import.meta.env.VITE_WEB_OFFICE_SERVER_URL

/**
 * weboffice 应用 ID
 */
export const WEB_OFFICE_APP_ID = import.meta.env.VITE_WEB_OFFICE_APP_ID

/**
 * 应用版本号
 */
export const APP_VERSION = import.meta.env.VITE_APP_VERSION || BUILD_MODE
